import { ChevronLeftIcon } from "@heroicons/react/24/outline";

interface PageLayoutProps {
    title: string;
    enableBackButton?: boolean;
    children: React.ReactNode;
    listing?: boolean;
}
// text-lg font-semibold mb-3
export const PageInnerLayout = ({ title, listing, enableBackButton = true, children }: PageLayoutProps) => {
    return (
        // <div className="w-full bg-white dark:bg-slate-800 overflow-y-auto">
        <div className="w-full px-6 pt-6 bg-white dark:bg-slate-800 rounded-lg border border-gray-200 dark:border-0 shadow-md overflow-y-auto">
            {/* <div className="w-full dark:text-white flex flex-col items-start gap-2 p-4 pb-6"> */}

            {/* Top Header */}
            <div className="flex flex-row items-center gap-2 bg-inherit py-1 w-full justify-between">

                <div className="">  {(title && listing) ?
                    <h4 className='text-xl dark:text-slate-100'>{title}</h4> :
                    <h3 className='text-lg font-semibold mb-2 dark:text-slate-100'>{title}</h3>
                }</div>

                <div className="">
                    {enableBackButton && (
                        <button
                            onClick={() => window.history.back()}
                            className="
                                    flex items-center gap-1
                            rounded-md px-3 py-1.5
                            text-sm font-semibold
                            bg-white text-slate-700 border border-slate-300
                            hover:bg-slate-50 hover:text-slate-900
                            dark:bg-slate-800 dark:text-slate-200 dark:border-slate-600
                            dark:hover:bg-slate-700 dark:hover:text-white
                            transition-colors
                                "
                        >
                            <ChevronLeftIcon className="h-5 w-5" />
                            <span>Back</span>
                        </button>
                    )}
                </div>






            </div>
            <div className="w-full">
                {children}
            </div>

            {/* </div> */}
        </div>
    );
};
